module.exports = __webpack_public_path__ + "static/media/IC204renewwithnewprice.3409b1ea.jpg";